import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("abkhazia",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.5L0 4.5L0 20.5L24 20.5L24 4.5Z"
                fill="#00993E" />
            <path
                d="M24 6.78516L0 6.78516L0 9.07102L24 9.07102V6.78516Z"
                fill="white" />
            <path
                d="M24 11.3564L0 11.3564L0 13.6423L24 13.6423V11.3564Z"
                fill="white" />
            <path
                d="M24 15.9287L0 15.9287L0 18.2146L24 18.2146V15.9287Z"
                fill="white" />
            <path
                d="M12.5469 4.5L0 4.5L0 11.3571L12.5469 11.3571L12.5469 4.5Z"
                fill="#C8312A" />
            <path
                d="M5.6371 8.13467C5.6371 8.13467 5.53795 8.16233 5.60574 8.69151C5.66139 9.12692 5.8941 9.26891 5.8941 9.26891L5.99579 9.53839L6.96004 9.54109C6.96004 9.54109 6.97775 9.37414 7.01468 9.32153C7.10625 9.19168 7.47 9.04362 7.62582 8.81967C7.79327 8.68341 7.70929 8.40483 8.04572 8.13602C8.21267 8.00246 7.84993 8.05912 7.84993 8.05912C7.65111 8.14715 7.55398 8.25036 7.50389 8.32253C7.47 8.46149 7.31418 8.57751 7.29951 8.47667C7.29951 8.47667 7.24285 8.3023 7.07286 7.963C7.05617 7.8625 6.98332 7.51477 6.96763 7.24968C6.9565 7.07699 6.72986 7.06654 6.71114 7.24192L6.68382 7.93636L6.62969 7.13399C6.60642 6.90701 6.34891 6.94074 6.33778 7.12893L6.32665 7.96435L6.2796 7.15457C6.20979 6.99976 6.02614 7.0915 6.02311 7.25912L5.99174 8.04698C5.99174 8.04698 5.95228 7.61561 5.94318 7.43349C5.93457 7.32388 5.74233 7.33197 5.72412 7.4888C5.69781 7.71545 5.65683 7.90027 5.63761 8.13501L5.6371 8.13467Z"
                fill="white" />
            <path
                d="M6.23631 6.65604L6.52923 6.05469L6.82215 6.65604L6.05469 6.28437H7.00326L6.2358 6.65604H6.23631Z"
                fill="white" />
            <path
                d="M8.51355 6.8953L7.74609 6.52363H8.69467L7.92721 6.8953L8.22013 6.29395L8.51355 6.8953Z"
                fill="white" />
            <path
                d="M9.96668 7.61014L9.19922 7.23847H10.1478L9.38033 7.61014L9.67325 7.00879L9.96668 7.61014Z"
                fill="white" />
            <path
                d="M10.8026 8.61991L10.0352 8.24824H10.9837L10.2163 8.61991L10.5092 8.01855L10.8021 8.61991H10.8026Z"
                fill="white" />
            <path
                d="M4.5444 6.8953L5.31185 6.52363H4.36328L5.13074 6.8953L4.83782 6.29395L4.5449 6.8953H4.5444Z"
                fill="white" />
            <path
                d="M3.09518 7.61014L3.86263 7.23847H2.91406L3.68152 7.61014L3.3886 7.00879L3.09568 7.61014H3.09518Z"
                fill="white" />
            <path
                d="M2.25584 8.61991L3.0233 8.24824H2.07422L2.84168 8.61991L2.54876 8.01855L2.25584 8.61991Z"
                fill="white" />
        </svg>
    `),e=i("abkhazia_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_92900)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M24 0.5L0 0.5L0 24.5L24 24.5L24 0.5Z"
                    fill="#00993E" />
                <path
                    d="M24 3.92871L0 3.92871L0 7.35751L24 7.35751V3.92871Z"
                    fill="white" />
                <path
                    d="M24 10.7852L0 10.7852L0 14.214L24 14.214V10.7852Z"
                    fill="white" />
                <path
                    d="M24 17.6436L0 17.6436L0 21.0724L24 21.0724V17.6436Z"
                    fill="white" />
                <path
                    d="M12.5469 0.5L0 0.5L0 10.7856L12.5469 10.7856L12.5469 0.5Z"
                    fill="#C8312A" />
                <path
                    d="M5.6371 7.04918C5.6371 7.04918 5.53795 7.09066 5.60574 7.88443C5.66139 8.53755 5.8941 8.75054 5.8941 8.75054L5.99579 9.15476L6.96004 9.1588C6.96004 9.1588 6.97775 8.90838 7.01468 8.82946C7.10625 8.63468 7.47 8.41259 7.62582 8.07667C7.79327 7.87229 7.70929 7.45441 8.04572 7.0512C8.21267 6.85086 7.84993 6.93586 7.84993 6.93586C7.65111 7.0679 7.55398 7.2227 7.50389 7.33097C7.47 7.5394 7.31418 7.71343 7.29951 7.56217C7.29951 7.56217 7.24285 7.30061 7.07286 6.79167C7.05617 6.64091 6.98332 6.11932 6.96763 5.72168C6.9565 5.46266 6.72986 5.44698 6.71114 5.71005L6.68382 6.75171L6.62969 5.54816C6.60642 5.20768 6.34891 5.25827 6.33778 5.54057L6.32665 6.7937L6.2796 5.57902C6.20979 5.34681 6.02614 5.48441 6.02311 5.73585L5.99174 6.91764C5.99174 6.91764 5.95228 6.27059 5.94318 5.9974C5.93457 5.83298 5.74233 5.84512 5.72412 6.08037C5.69781 6.42034 5.65683 6.69757 5.63761 7.04968L5.6371 7.04918Z"
                    fill="white" />
                <path
                    d="M6.23631 4.83074L6.52923 3.92871L6.82215 4.83074L6.05469 4.27323H7.00326L6.2358 4.83074H6.23631Z"
                    fill="white" />
                <path
                    d="M8.51355 5.19012L7.74609 4.63261H8.69467L7.92721 5.19012L8.22013 4.28809L8.51355 5.19012Z"
                    fill="white" />
                <path
                    d="M9.96668 6.26238L9.19922 5.70487H10.1478L9.38033 6.26238L9.67325 5.36035L9.96668 6.26238Z"
                    fill="white" />
                <path
                    d="M10.8026 7.77703L10.0352 7.21952H10.9837L10.2163 7.77703L10.5092 6.875L10.8021 7.77703H10.8026Z"
                    fill="white" />
                <path
                    d="M4.5444 5.19012L5.31185 4.63261H4.36328L5.13074 5.19012L4.83782 4.28809L4.5449 5.19012H4.5444Z"
                    fill="white" />
                <path
                    d="M3.09518 6.26238L3.86263 5.70487H2.91406L3.68152 6.26238L3.3886 5.36035L3.09568 6.26238H3.09518Z"
                    fill="white" />
                <path
                    d="M2.25584 7.77703L3.0233 7.21952H2.07422L2.84168 7.77703L2.54876 6.875L2.25584 7.77703Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_92900">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Abkhazia,e as AbkhaziaRounded};
